import Icon from "@mui/material/Icon";
import SubirCertificado from "Fiscal/SubirCertificado";
import DashboardNotificaciones from "Fiscal/DashboardNotificaciones";
import FacturasElectronicasDgii from "Fiscal/facturaselectronicadgii";
import GastosElectronicos from "Fiscal/gastoselectronicos";
import ComprasElectronicas from "Fiscal/compraselectronicas";
import PagosElectronicos from "Fiscal/pagoselectronicos";
import ExportacionesElectronicas from "Fiscal/exportacionelectronicas";
import MantenimientoFacturasEmitidas from "facturapos/MantenimientoFacturasEmitidas";
import ListadoNotasCreditoDebitoEmitidas from "facturapos/ListadoNotasCreditoDebitoEmitidas";
import ConfiguracionDocumentosFiscales from "facturapos/reglasventas";


const routes = [
  {
    type: "collapse",
    name: "Subir Certificado",
    key: "subircertificado",
    icon: <Icon fontSize="small">upload_file</Icon>,
    route: "/subircertificado",
    component: <SubirCertificado />,
  },
  {
    type: "collapse",
    name: "Dashboard Notificaciones",
    key: "dashboardnotificaciones",
    programa: "dashboardnotificaciones",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/dashboardnotificaciones",
    component: <DashboardNotificaciones />,
  },
  {
    type: "collapse",
    name: "Electronicos",
    key: "facturacion",
    programa: "facturacion",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/facturacion",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Facturas Electronicas DGII",
        key: "facturaselectronicasdgii",
        route: "/facturacion/facturaselectronicasdgii",
        component: <FacturasElectronicasDgii />,
      },
      {
        type: "collapse",
        name: "Gastos Electrónicos",
        key: "gastoselectronicos",
        programa: "gastoselectronicos",
        aliases: ["gastos"],
        route: "/gastos/gastoselectronicos",
        component: <GastosElectronicos />,
      },
      {
        type: "collapse",
        name: "Compras Electrónicas",
        key: "compraselectronicas",
        programa: "compraselectronicas",
        aliases: ["desembolso"],
        route: "/facturacion/compraselectronicas",
        component: <ComprasElectronicas />,
      },
      {
        type: "collapse",
        name: "Pagos al Exterior",
        key: "pagoselectronicos",
        programa: "pagoselectronicos",
        aliases: ["desembolso"],
        route: "/facturacion/pagoselectronicos",
        component: <PagosElectronicos />,
      },
      {
        type: "collapse",
        name: "Comprobante para Exportaciones",
        key: "exportacionelectronicas",
        programa: "exportacionelectronicas",
        aliases: ["desembolso"],
        route: "/facturacion/exportacionelectronicas",
        component: <ExportacionesElectronicas />,
      },
      {
        type: "collapse",
        name: "Facturas Emitidas",
        key: "mantenimientofacturasemitidas",
        route: "/facturacion/facturasemitidas",
        component: <MantenimientoFacturasEmitidas />,
      },

      {
        type: "collapse",
        name: "NC/ND Emitidas",
        key: "notacreditodebitoemitidas",
        route: "/facturacion/notasdebitocreditoemitidas",
        component: <ListadoNotasCreditoDebitoEmitidas />,
      },

      {
        type: "collapse",
        name: "Reglas de Ventas",
        key: "regladeventas",
        route: "/facturacion/reglasdeventas",
        component: <ConfiguracionDocumentosFiscales />,
      },
      

      
    ],
  },
];

export default routes;
